import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { FacebookMcIcon, GoogleMcIcon, LinkedInMcIcon } from "assets/Icons";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { MUIGrey } from "shared/SharedStyles/styleConstants";
import { ISocialActionItems } from "./AuthModel";

export const SocialButtons = ({ handleGetRedirect, isSignUp, buttonType }: ISocialActionItems) => {
    return (<>
        {buttonType === 'button' ? <>
            <Stack gap={2}>
                <ShButton fullWidth variant="outlined" aria-label={`Sign ${isSignUp ? 'up' : 'in'} with Google`}
                    onClick={() => handleGetRedirect('google')}>
                    <Stack direction="row" p={1} gap={1} justifyContent="start" width="100%">
                        <GoogleMcIcon />
                        <Typography color={MUIGrey} variant='body1'>
                            {`Sign ${isSignUp ? 'up' : 'in'} with Google`}
                        </Typography>
                    </Stack>
                </ShButton>
                <ShButton fullWidth variant="outlined" aria-label={`Sign ${isSignUp ? 'up' : 'in'} with Facebook`}
                    onClick={() => handleGetRedirect('facebook')}>
                    <Stack direction="row" p={1} gap={1} justifyContent="start" width="100%">
                        <FacebookMcIcon />
                        <Typography color={MUIGrey} variant='body1'>
                            {`Sign ${isSignUp ? 'up' : 'in'} with Facebook`}
                        </Typography>
                    </Stack>
                </ShButton>
                <ShButton fullWidth variant="outlined" aria-label={`Sign ${isSignUp ? 'up' : 'in'} with LinkedIn`}
                    onClick={() => handleGetRedirect('linkedin')} >
                    <Stack direction="row" p={1} gap={1} justifyContent="start" width="100%">
                        <LinkedInMcIcon />
                        <Typography color={MUIGrey} variant='body1'>
                            {`Sign ${isSignUp ? 'up' : 'in'} with LinkedIn`}
                        </Typography>
                    </Stack>
                </ShButton>
            </Stack></> : <>
            <Stack direction='row' columnGap={2}>
                <Tooltip title={`Sign ${isSignUp ? 'up' : 'in'} with Google`}>
                    <IconButton aria-label={`Sign ${isSignUp ? 'up' : 'in'} with Google`}
                        onClick={() => handleGetRedirect('google')}>
                        <GoogleMcIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={`Sign ${isSignUp ? 'up' : 'in'} with Facebook`}>
                    <IconButton aria-label={`Sign ${isSignUp ? 'up' : 'in'} with Facebook`}
                        onClick={() => handleGetRedirect('facebook')}>
                        <FacebookMcIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={`Sign ${isSignUp ? 'up' : 'in'} with LinkedIn`}>
                    <IconButton aria-label={`Sign ${isSignUp ? 'up' : 'in'} with LinkedIn`}
                        onClick={() => handleGetRedirect('linkedin')}>
                        <LinkedInMcIcon />
                    </IconButton>
                </Tooltip>
                {/* Outlook sign in is pending from the api. To be uncommented once api is done*/}
                {/* <Tooltip title="Sign in with Outlook">
                            <IconButton aria-label='Sign in with Outlook' onClick={() => { dispatch(getOutlookUrl()); setAuthProvider(SocialLoginProviders.Outlook) }}>
                                <OutlookMcIcon />
                            </IconButton>
                        </Tooltip> */}
            </Stack>
        </>}
    </>)
}